import { render, staticRenderFns } from "./MusicView.vue?vue&type=template&id=4a895e5a&"
import script from "./MusicView.vue?vue&type=script&lang=js&"
export * from "./MusicView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports